import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import PieChartLoadingState from '../LoadingState/PieChartLoadingState'

export const PieChartEmptyState = ({
  title = 'No Data',
  subtitle,
  height,
  style = {},
  className = '',
  titleFontSize: _titleFontSize,
  subtitleFontSize: _subtitleFontSize,
  ...props
}) => {
  const titleFontSize = _titleFontSize ?? Math.max(height / 18, 16)
  const subtitleFontSize = _subtitleFontSize ?? Math.max(height / 35, 16)
  const { grid } = props ?? {}

  return (
    <>
      <PieChartLoadingState animate={false} {...props} height={height} />
      <div
        className={clsx('absolute top-0 bottom-0 right-0 left-0 flex flex-col items-center justify-center gap-md', className)}
        style={{
          zIndex: 10,
          pointerEvents: 'none',
          ...style
        }}
      >
        <div
          style={{
            width: height * 0.8,
            height: height * 0.8,
            margin: grid ? `${-(grid.top + grid.bottom) * 2}px 0 0 ${grid.left}px` : undefined
          }}
          className='flex items-center justify-center'
        >
          <p className='font-bold m-0 text-center' style={{ fontSize: titleFontSize, lineHeight: 0.9 }}>{title}</p>
          {subtitle?.length && (<p className='font-light m-0 text-center' style={{ fontSize: subtitleFontSize, lineHeight: 0.9 }}>{subtitle}</p>)}
        </div>
      </div>
    </>
  )
}

PieChartEmptyState.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  height: PropTypes.number,
  style: PropTypes.object,
  className: PropTypes.string,
  titleFontSize: PropTypes.number,
  subtitleFontSize: PropTypes.number
}

export default PieChartEmptyState
